export default __webpack_public_path__ + "static/PurpleFibre_lifestyle-c0f1daaa8f04e23e45f4237aae2ee212.png";